(function () {
  'use strict';

  var sensitiveNamePattern = /password|token|secret|captcha|authenticity|csrf/i;
  var technicalNamePattern = /^(form_type|utf8|return_to)$/i;
  var modalId = 'DomoxaFormSuccessModal';
  var pendingStorageKey = 'domoxa_pending_form_submit';
  var attributionStorageKey = 'domoxa_attribution_parameters';
  var legacyUtmStorageKey = 'domoxa_utm_parameters';
  var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var attributionKeys = [
    'gclid',
    'gbraid',
    'wbraid',
    'gad_source',
    'gad_campaignid'
  ].concat(utmKeys);
  var attributionFieldDefinitions = [
    { key: 'gclid', name: 'contact[Google Ads - GCLID]' },
    { key: 'gbraid', name: 'contact[Google Ads - GBRAID]' },
    { key: 'wbraid', name: 'contact[Google Ads - WBRAID]' },
    { key: 'gad_source', name: 'contact[Google Ads - Source]' },
    { key: 'gad_campaignid', name: 'contact[Google Ads - Campaign ID]' },
    { key: 'utm_source', name: 'contact[UTM - source]' },
    { key: 'utm_medium', name: 'contact[UTM - medium]' },
    { key: 'utm_campaign', name: 'contact[UTM - campaign]' },
    { key: 'utm_content', name: 'contact[UTM - content]' },
    { key: 'utm_term', name: 'contact[UTM - term]' },
    { key: 'landing_page_url', name: 'contact[Landing URL]' },
    { key: 'form_source', name: 'contact[Form source]' },
    { key: 'form_submitted_at', name: 'contact[Form submitted at]' }
  ];

  function normaliseFieldName(name) {
    return name
      .replace(/^contact\[/i, '')
      .replace(/\]$/, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/gi, '_')
      .replace(/^_|_$/g, '');
  }

  function isTrackableField(field) {
    var name = field.name || '';
    var type = (field.type || '').toLowerCase();

    return name &&
      !technicalNamePattern.test(name) &&
      type !== 'submit' &&
      type !== 'button' &&
      type !== 'file' &&
      type !== 'password' &&
      !sensitiveNamePattern.test(name) &&
      !(field.dataset && field.dataset.domoxaAttributionField) &&
      (type !== 'checkbox' || field.checked) &&
      (type !== 'radio' || field.checked);
  }

  function collectFormFields(form) {
    var fields = [];

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!isTrackableField(field)) return;

      var key = normaliseFieldName(field.name);
      if (!key) return;

      if (fields.indexOf(key) === -1) fields.push(key);
    });

    return fields;
  }

  function getAttributionParameters() {
    var parameters = {};
    var hasUrlParameters = false;

    attributionKeys.forEach(function (key) { parameters[key] = ''; });
    parameters.landing_page_url = '';

    try {
      var stored = JSON.parse(
        sessionStorage.getItem(attributionStorageKey) ||
        sessionStorage.getItem(legacyUtmStorageKey) ||
        '{}'
      );
      attributionKeys.forEach(function (key) {
        if (stored[key]) parameters[key] = String(stored[key]).slice(0, 200);
      });
      if (stored.landing_page_url) parameters.landing_page_url = String(stored.landing_page_url).slice(0, 2000);
    } catch (error) {
      // Private browsing or a restrictive browser policy may disable storage.
    }

    try {
      var searchParams = new URLSearchParams(window.location.search);
      attributionKeys.forEach(function (key) {
        var value = searchParams.get(key);
        if (!value) return;
        parameters[key] = value.trim().slice(0, 200);
        hasUrlParameters = true;
      });

      if (hasUrlParameters) {
        if (!parameters.landing_page_url) parameters.landing_page_url = window.location.href.slice(0, 2000);
        sessionStorage.setItem(attributionStorageKey, JSON.stringify(parameters));
      }
    } catch (error) {
      // Invalid query strings or private browsing do not block form tracking.
    }

    return parameters;
  }

  // Kept as a compatibility alias for the existing success-tracking flow.
  function getUtmParameters() {
    return getAttributionParameters();
  }

  function ensureAttributionFields(form) {
    if (!form || getFormType(form) === 'newsletter') return getAttributionParameters();

    var attribution = getAttributionParameters();
    attribution.form_source = 'Shopify contact form';
    attribution.form_submitted_at = new Date().toISOString();

    attributionFieldDefinitions.forEach(function (definition) {
      var field = form.querySelector('[data-domoxa-attribution-field="' + definition.key + '"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = definition.name;
        field.setAttribute('data-domoxa-attribution-field', definition.key);
        form.appendChild(field);
      }
      field.value = attribution[definition.key] || '';
    });

    return attribution;
  }

  function isShopifyLeadForm(form) {
    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/contact') !== -1 || form.querySelector('[name^="contact["]');
  }

  function getFormType(form) {
    var identifier = ((form.id || '') + ' ' + (form.className || '')).toLowerCase();
    var newsletterTag = form.querySelector('[name="contact[tags]"]');

    return identifier.indexOf('newsletter') !== -1 || (newsletterTag && newsletterTag.value === 'newsletter')
      ? 'newsletter'
      : 'contact';
  }

  function pushFormEvent(form, formType, values, pageLocation, pagePath, utmParameters) {
    var attribution = utmParameters || getUtmParameters();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submit',
      form_status: 'success',
      form_id: form.id || '',
      form_type: formType,
      form_fields: values,
      form_page_location: pageLocation || window.location.href,
      form_page_path: pagePath || window.location.pathname,
      utm_source: attribution.utm_source,
      utm_medium: attribution.utm_medium,
      utm_campaign: attribution.utm_campaign,
      utm_content: attribution.utm_content,
      utm_term: attribution.utm_term,
      gclid: attribution.gclid,
      gbraid: attribution.gbraid,
      wbraid: attribution.wbraid,
      gad_source: attribution.gad_source,
      gad_campaignid: attribution.gad_campaignid,
      landing_page_url: attribution.landing_page_url
    });
  }

  function getModal() {
    var modal = document.getElementById(modalId);
    if (modal) return modal;

    modal = document.createElement('dialog');
    modal.id = modalId;
    modal.className = 'domoxa-form-modal';
    modal.setAttribute('aria-labelledby', modalId + '-title');
    modal.setAttribute('aria-describedby', modalId + '-message');
    modal.innerHTML =
      '<div class="domoxa-form-modal__inner">' +
        '<button type="button" class="domoxa-form-modal__close" aria-label="Fermer">&times;</button>' +
        '<div class="domoxa-form-modal__icon" aria-hidden="true">✓</div>' +
        '<h2 id="' + modalId + '-title"></h2>' +
        '<p id="' + modalId + '-message"></p>' +
        '<button type="button" class="domoxa-form-modal__button">Fermer</button>' +
      '</div>';

    var style = document.createElement('style');
    style.textContent =
      '.domoxa-form-modal{border:0;border-radius:18px;max-width:min(92vw,520px);padding:0;color:#182522;box-shadow:0 24px 80px rgba(0,0,0,.24)}' +
      '.domoxa-form-modal::backdrop{background:rgba(14,29,25,.62)}' +
      '.domoxa-form-modal__inner{position:relative;padding:42px 36px 34px;text-align:center;background:#fff}' +
      '.domoxa-form-modal__close{position:absolute;top:12px;right:14px;border:0;background:transparent;color:#52635e;font-size:30px;line-height:1;cursor:pointer}' +
      '.domoxa-form-modal__icon{display:grid;place-items:center;width:54px;height:54px;margin:0 auto 18px;border-radius:50%;background:#e7f4e9;color:#2f8b4b;font-size:30px;font-weight:700}' +
      '.domoxa-form-modal h2{margin:0 0 10px;font-size:clamp(22px,4vw,30px);line-height:1.15}' +
      '.domoxa-form-modal p{margin:0 auto 24px;max-width:38ch;color:#52635e;line-height:1.55}' +
      '.domoxa-form-modal__button{border:0;border-radius:999px;padding:12px 24px;background:#182522;color:#fff;font:inherit;font-weight:600;cursor:pointer}' +
      '@media (max-width:600px){.domoxa-form-modal__inner{padding:38px 24px 28px}}';
    document.head.appendChild(style);
    document.body.appendChild(modal);

    function closeModal() {
      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      if (modal.lastActiveElement && typeof modal.lastActiveElement.focus === 'function') {
        modal.lastActiveElement.focus();
      }
    }

    modal.querySelector('.domoxa-form-modal__close').addEventListener('click', closeModal);
    modal.querySelector('.domoxa-form-modal__button').addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    return modal;
  }

  function showModal(formType, isSuccess) {
    var modal = getModal();
    var icon = modal.querySelector('.domoxa-form-modal__icon');
    var title = modal.querySelector('#' + modalId + '-title');
    var message = modal.querySelector('#' + modalId + '-message');

    icon.textContent = isSuccess ? '✓' : '!';
    title.textContent = isSuccess
      ? (formType === 'newsletter' ? 'Merci pour votre inscription !' : 'Merci, votre demande est bien envoyée')
      : 'Votre demande n’a pas pu être envoyée';
    message.textContent = isSuccess
      ? (formType === 'newsletter' ? 'Vous êtes bien inscrit à notre newsletter.' : 'Nous revenons vers vous rapidement.')
      : 'Un problème est survenu. Vérifiez votre connexion puis réessayez.';
    modal.querySelector('.domoxa-form-modal__button').textContent = isSuccess ? 'Fermer' : 'Réessayer';
    modal.lastActiveElement = document.activeElement;

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    modal.querySelector('.domoxa-form-modal__button').focus();
  }

  function savePendingForm(form) {
    var attribution = ensureAttributionFields(form);
    var pending = {
      formId: form.id || '',
      formType: getFormType(form),
      values: collectFormFields(form),
      formPageLocation: window.location.href,
      formPagePath: window.location.pathname,
      utm: attribution,
      savedAt: Date.now()
    };

    try {
      sessionStorage.setItem(pendingStorageKey, JSON.stringify(pending));
    } catch (error) {
      // Private browsing or a restrictive browser policy may disable storage.
    }
  }

  function readPendingForm() {
    try {
      var raw = sessionStorage.getItem(pendingStorageKey);
      if (!raw) return null;

      var pending = JSON.parse(raw);
      if (!pending || !pending.savedAt || Date.now() - pending.savedAt > 15 * 60 * 1000) {
        sessionStorage.removeItem(pendingStorageKey);
        return null;
      }

      return pending;
    } catch (error) {
      return null;
    }
  }

  function clearPendingForm() {
    try {
      sessionStorage.removeItem(pendingStorageKey);
    } catch (error) {
      // Nothing else to do when storage is unavailable.
    }
  }

  function hasSuccessState(form) {
    return !!form.querySelector(
      '.domoxa-form-status--success, .domoxa-lead-form__status--success, .newsletter-form__message--success, [role="status"]'
    );
  }

  function pushSuccessForForm(form, formType, pageLocation, pagePath) {
    if (!form || form.dataset.domoxaSuccessTracked === 'true') return;
    form.dataset.domoxaSuccessTracked = 'true';
    pushFormEvent(
      form,
      formType || getFormType(form),
      collectFormFields(form),
      pageLocation,
      pagePath
    );
  }

  function rememberFormFromEvent(event) {
    var form = event.target;
    if (form && form.tagName === 'FORM' && isShopifyLeadForm(form)) {
      ensureAttributionFields(form);
      savePendingForm(form);
    }
  }

  function rememberFormFromClick(event) {
    var target = event.target;
    var submitter = target && target.closest ? target.closest('button, input') : null;
    var form = submitter && submitter.form;

    if (!form || !isShopifyLeadForm(form)) return;
    if ((submitter.type || '').toLowerCase() !== 'submit') return;

    // Do not persist a pending conversion when the shared lead form is invalid.
    // The lead-form guard prevents the navigation, but this listener runs first
    // during capture and would otherwise retain an invalid submission attempt.
    if (form.dataset.domoxaLeadReady === 'true' && typeof form.checkValidity === 'function' && !form.checkValidity()) return;

    // hCaptcha may call form.submit(), which bypasses the submit event.
    ensureAttributionFields(form);
    savePendingForm(form);
  }

  function prepareAttributionFields() {
    document.querySelectorAll('form').forEach(function (form) {
      if (isShopifyLeadForm(form)) ensureAttributionFields(form);
    });
  }

  function handleSuccessReturn() {
    var params = new URLSearchParams(window.location.search);
    var formType = null;

    if (params.get('contact_posted') === 'true') formType = 'contact';
    if (params.get('customer_posted') === 'true') formType = 'newsletter';
    var pending = readPendingForm();
    if (pending && formType) {
      pending.formType = pending.formType || formType;
      pushFormEvent(
        {
          id: pending.formId,
          elements: []
        },
        pending.formType,
        pending.values,
        pending.formPageLocation,
        pending.formPagePath,
        pending.utm
      );
      clearPendingForm();

      // Keep the success state in the dataLayer without leaving a tracking query
      // parameter visible in the address bar or retriggering the event on refresh.
      window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
      showModal(pending.formType, true);
      return;
    }

    // Some native/embedded forms render their success state without a query
    // parameter. Track those forms as well so every successful lead submission
    // emits the same conversion contract.
    document.querySelectorAll('form').forEach(function (form) {
      if (isShopifyLeadForm(form) && hasSuccessState(form)) {
        pushSuccessForForm(form);
      }
    });
  }

  // Do not cancel the native Shopify submit: hCaptcha and Shopify may submit
  // the form through form.submit(), which bypasses submit event listeners.
  // We remember the values first, then handle success after Shopify returns.
  window.addEventListener('submit', rememberFormFromEvent, true);
  window.addEventListener('click', rememberFormFromClick, true);

  getAttributionParameters();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      prepareAttributionFields();
      handleSuccessReturn();
    });
  } else {
    prepareAttributionFields();
    handleSuccessReturn();
  }
}());
